<template>
    
    <div class="content">
        <div class="text">
            <h2>{{texts.title}}</h2>
            <span>发布时间：{{texts.createTime}}</span>
            <p>
                {{texts.contents}}
            </p>
            <img v-for="item in texts.picList" :key="item.id" :src="item.url" alt="">
        </div>

        <div class="pageSwitch d_f jc_c ai_c">
            <!-- <div>上一页</div> -->
            <button @click="retu">返回</button>
            <!-- <div>下一页</div> -->
        </div>

        <!-- <div class="m-link">
            <a-divider>分享至</a-divider>
            <div class="d_f f_1 jc_sb ai_c">
                <a href="javascript:void"><img class="h_1" src="../../assets/xl.png" alt=""><p>微信</p></a>
                <a href="javascript:void"><img class="h_1" src="../../assets/wx.png" alt=""><p>QQ</p></a>
                <a href="javascript:void"><img class="h_1" src="../../assets/xl.png" alt=""><p>微博</p></a>
            </div>
        </div> -->
    </div>



</template>

<script>

import cases from '../../api/case'
export default {
    data(){
        return {
            texts : {}
        }
    },
    created(){
        let id = this.$route.query.id;
        if(!id){
            // 直接从路由跳转过来的没有带任何参数的 返回新闻列表页
            this.$router.push({path:'/case'});
            return;
        }
        cases.selectProjectInfoById({
            id
        }).then(res=>{
            this.texts = res;
            console.log(res)
        })
    },
    methods : {
        retu(){
            this.$router.push({path:'/case'});
        }
    }    
}
</script>

<style lang="scss" scoped>
    .content{
        width: 1200px;
        margin: auto;
        padding: 100px 0 0;
        .text{
            padding-bottom: 50px;
            border-bottom: 1px solid #ccc;
            h2,span,p,img{
                display: block;
                text-align: center;
            }
            h2{
                font-size: 36px;
            }
            span{
                font-size: 18px;
                color: #ccc;
            }
            p{
                font-size: 18px;
                margin: 30px 0;
                color: #202737;
            }
            img{
                width: 930px;
                margin: auto;
                margin-bottom: 20px;
            }
        }
        .pageSwitch{
            padding: 50px 0;
            button{
                width: 140px;
                height:54px;
                line-height: 54px;
                background-color: #0067cc;
                font-size: 18px;
                color: #fff;
            }
        }
        .m-link{
            display: none;
        }
    }

    @media screen and (max-width: 750px){
        .content{
            width: 100%;
            padding: 13.298vw 2.66vw;
            .text{
                padding-bottom: 0;
                border-bottom: none;
                img{
                    width: 100%;
                    margin-bottom: 2.66vw;
                }
                p{
                    text-align: left;
                    font-size: 3.458vw;
                    line-height: 5.851vw;
                }
                span{
                    font-size: 3.458vw;
                }
                h2{
                    font-size: 4.521vw;
                    margin-bottom: 3.989vw;
                }
            }
            .pageSwitch{
                display: none;
            }
            .m-link{
                display: block;
                width: 53.191vw;
                margin: auto;
            }
        }
    }
</style>